// libs
import React from 'react';

// helpers
import { inPriceFormat } from 'shared/helpers/utils';

//components
import WishlistButton from './components/WishlistButton';

// styles
import {
  Amount,
  Container,
  Currency,
  DataDesktop as Data,
  Discount,
  Image,
  InfoDesktop as Info,
  PriceDetailsDesktop as PriceDetails,
  SaleBanner,
  WishlistButtonContainerDesktop as WishlistButtonContainer,
} from './styles';

// constants
import { IMAGE_ALT, IMAGE_WIDTH, PRICE_OFF } from './constants';
import { DEFAULT_CURRENCY } from 'shared/constants';

// def
import { IPriceRevealProps } from './types';

function PriceReveal({
  priceRevealData,
  priceRevealConfig,
  productId,
  wishlistMetaData,
}: IPriceRevealProps) {
  const {
    bannerImage = '',
    bannerImageAspectRatio,
    bannerBorderColor,
    bannerHeaderColor,
    bannerBgColor,
    sellingPriceColor,
    discountColor,
    bannerText,
    bannerTextColor,
  } = priceRevealConfig;

  return (
    <Container borderColor={bannerBorderColor}>
      <SaleBanner headerColor={bannerHeaderColor}>
        <Image
          src={bannerImage}
          alt={IMAGE_ALT}
          aspectRatio={bannerImageAspectRatio}
          width={IMAGE_WIDTH}
        />
      </SaleBanner>
      <Info bgColor={bannerBgColor}>
        <div>
          <PriceDetails>
            {priceRevealData.sp && (
              <Amount color={sellingPriceColor}>
                <Currency>{DEFAULT_CURRENCY}</Currency>
                {inPriceFormat(priceRevealData.sp)}
              </Amount>
            )}
            {priceRevealData.discount && (
              <Discount color={discountColor}>
                ({priceRevealData.discount}% {PRICE_OFF})
              </Discount>
            )}
          </PriceDetails>
          {bannerText && <Data color={bannerTextColor}>{bannerText}</Data>}
        </div>
        <WishlistButtonContainer
          CustomWishlist={WishlistButton}
          productId={productId}
          trackingMetaData={{ ...wishlistMetaData, wishlistFromPriceRevealBanner: true }}
          canShowNotification
        />
      </Info>
    </Container>
  );
}

export default PriceReveal;
